import { uploadToMediaManagement } from "../functions/upload_to_MM.jsx";
export const fetchBannerFile = async ({
  bannerData,
  defaultCampaigns,
  selectedCategory,
  campaignDescription,
  productImageUrl,
  language,
  marketingGoals,
  targetAudience,
  vibeAndTone,
  bannerUrl,
  setBannerUrl,
  setCurrentBalance,
  setAllGenratedBanners,
  ChangeFetchBannerFileStatus,
  aspectBannerRatio,
  templateBanner,
  setSpinning,
  getToken,
  configData,
  navigate,
  notify
}) => {
    let bannerBody = bannerData
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    bannerBody = {
          ...bannerData,
    }

    // await sleep(5000);
    // handleSpin('signage')
    // return false
    if(bannerBody){
      if(selectedCategory === "manual"){
          bannerBody = {
            ...bannerBody,
            Image_Url: productImageUrl,
            product_title: campaignDescription.split("\n").join(" ")
          }
      }
      else{
        bannerBody = {
          ...bannerBody,
          Image_Url: defaultCampaigns[selectedCategory].Product_image,
          product_title: `${defaultCampaigns[selectedCategory].Product_title} ${defaultCampaigns[selectedCategory].Price}. ${defaultCampaigns[selectedCategory].Description ? defaultCampaigns[selectedCategory].Description : ""}`,
      }
      }
      if(templateBanner){
        bannerBody = {
          ...bannerBody,
          logo_url: bannerUrl,
          banner_director_instructions: `Use the attached image as a template and replace only the product image and promotion text`
        }
      }
      bannerBody = {
          ...bannerBody,
          banner_id: `Banner_${bannerData?.chain_name ?? ""}_${language}_${hours}_${minutes}_${seconds}`,
          banner_ratio: aspectBannerRatio,
        }
        try {
        const token = getToken()
        const res = await fetch(`${configData.DEMO_URL}/CreateBanner`, {
            method: "POST",
            headers: {
            "x-access-token": token,
            "Content-Type": "application/json",
            // add auth token if needed
            },
            body: JSON.stringify(bannerBody),
        });

        if (!res.ok) {
          setSpinning(prev => ({ ...prev, ["signage"]: false }));
          let errorMessage = `Request failed (${res.status})`;

          try {
            const errorBody = await res.json();
            if (errorBody?.message) {
              errorMessage = errorBody.message;
            }
          } catch (_) {
          }

          const error = new Error(errorMessage);
          error.status = res.status;
          throw error;
        }

        const response = await res.json();
        
        setBannerUrl(`${response.banner_url}`)
        setSpinning(prev => ({ ...prev, ["signage"]: false }));
        setCurrentBalance(response.current_balance)

        ChangeFetchBannerFileStatus(false);
        const bodyData = {
          bannerUrl: response.banner_url,
          banner_id: bannerBody.banner_id
        };
        uploadToMediaManagement({
          uploadData: {"uploadBannerData": bodyData},
          marketingGoals,
          targetAudience,
          vibeAndTone,
          aspectBannerRatio,
          setAllGenratedBanners,
          getToken,
          configData,
          notify,
        });

        // setBannerGif("https://storage.googleapis.com/catch-display/TT/banners/29-10-25_12-30/%D7%97%D7%95%D7%9E%D7%A5_%D7%91-_59_90(%D7%9E%D7%9B%D7%95%D7%9C%D7%AA.)_100312.gif")
        // return
        return { banner_url: response.banner_url, banner_id: bannerBody.banner_id };
            
        }catch (error) {
          if (error.status === 401 || error.status === 403) {
            setSpinning(prev => ({ ...prev, ["signage"]: false }));
            navigate("/");
          } else {
            notify(error.message, "error");
            ChangeFetchBannerFileStatus(false);
          }

          setSpinning(prev => ({ ...prev, ["signage"]: false }));
          ChangeFetchBannerFileStatus(false);
          return { banner_url: false, banner_id: false };
        }
    };
    return { banner_url: false, banner_id: false };
  }
